module.exports = __webpack_public_path__ + "img/symbol_1.bdcbb328.png";